import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import '../assets/custom.css';
import fullAnimals from '../assets/images/animals/test/Full.jpg';
import halfAnimals from '../assets/images/animals/test/Half.jpg';
import oneFourthAnimals from '../assets/images/animals/test/OneFourth.jpg';
import oneEighthAnimals from '../assets/images/animals/test/OneEighth.jpg';

class AnimalsComponent extends Component {

    render() {
        return (
            <div style={{overFlowX:'auto'}}>
                <div style={{marginLeft:20}}>Small Size</div>
                <div>

                <img src={oneEighthAnimals}/>
                <br/>
                <hr/>
                </div>
                <div>
                    <div style={{marginLeft:20}}>
                    Middle Size
                    </div>
                <img src={oneFourthAnimals}/>
                <br/>
                    <hr/>
                </div>
                <div>
                <div style={{marginLeft:20}}>
                    Big Size
                </div>
                <img src={halfAnimals}/>
                <br/>
                <hr/>
                </div>
                <div>
                <div style={{marginLeft:20}}>
                    Full Size
                </div>
                <img src={fullAnimals}/>
                <br/>
                <hr/>
                </div>
            </div>
        )
    }
}

export default AnimalsComponent;



// WEBPACK FOOTER //
// ./src/StudentsComponent/Animals.js